import { createApp } from 'vue';
import BasicFreeAppView from '../../free/BasicFreeAppView.vue'

const appElements = document.querySelectorAll('.vue-basic-free-app-view')
Array.from(appElements).forEach(element => {
  createApp(BasicFreeAppView).mount(element);
});